export enum ApiUserRole {
	admin = 'admin',
  user = 'user',
  read_only = 'read_only'
}